import { useState } from 'react';

import PropTypes from 'prop-types';

import { Link } from '@hh.ru/redux-spa-middleware';

import Checkbox from 'bloko/blocks/checkbox';
import BlokoLink from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import toggleActivity from 'components/Admin/CrmActivities/CrmActivity/toggleActivity';
import TableCell, { TableCellKind } from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { useDispatch } from 'store/utils';

const CrmActivity = ({
    crmActivityTypeId,
    title,
    monthlyTotal,
    monthlySent,
    weeklyTotal,
    weeklySent,
    dailyTotal,
    dailySent,
    enabled,
}) => {
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(enabled);
    const [disabled, setDisabled] = useState(false);
    const trl = useTrls();

    const onChange = () => dispatch(toggleActivity(crmActivityTypeId, checked, setChecked, setDisabled));
    return (
        <TableRow key={crmActivityTypeId}>
            <TableCell>
                <BlokoLink Element={Link} to={`/new/admin/crm/${crmActivityTypeId}/`}>
                    {title}
                </BlokoLink>
            </TableCell>
            <TableCell>{monthlyTotal}</TableCell>
            <TableCell>{monthlySent}</TableCell>
            <TableCell>{weeklyTotal}</TableCell>
            <TableCell>{weeklySent}</TableCell>
            <TableCell>{dailyTotal}</TableCell>
            <TableCell>{dailySent}</TableCell>
            <TableCell kind={TableCellKind.Title}>
                <Checkbox onChange={onChange} checked={checked} disabled={disabled}>
                    <span>{checked ? trl('admin.CrmActivities.enabled') : trl('admin.CrmActivities.notEnabled')}</span>
                </Checkbox>
            </TableCell>
        </TableRow>
    );
};

CrmActivity.propTypes = {
    crmActivityTypeId: PropTypes.number,
    title: PropTypes.string,
    monthlyTotal: PropTypes.number,
    monthlySent: PropTypes.number,
    weeklyTotal: PropTypes.number,
    weeklySent: PropTypes.number,
    dailyTotal: PropTypes.number,
    dailySent: PropTypes.number,
    enabled: PropTypes.bool,
};

export default CrmActivity;
